import { authFetch } from "@/utils/auth-fetch";

export const addToFavorites = async (teacherId: string, accessToken: string) => {
  const response = await authFetch("/api/favorites/add", accessToken, {
    method: "POST",
    body: JSON.stringify({ teacherId }),
  });

  if (!response.ok) {
    throw new Error("Failed to add to favorites");
  }
};

export const removeFromFavorites = async (
  teacherId: string,
  accessToken: string,
) => {
  const response = await authFetch("/api/favorites/remove", accessToken, {
    method: "POST",
    body: JSON.stringify({ teacherId }),
  });

  if (!response.ok) {
    throw new Error("Failed to remove from favorites");
  }
};
